import { Link } from 'react-router-dom'
import { useMemo } from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { Button } from 'app/components/ui/button'
import { PageScroll } from 'app/components/layout/PageScroll'
import SimpleTable from 'app/components/table/SimpleTable'
import { CallJson } from 'app/types/entities'
import { formatDate } from 'app/date.utils'
import type { UseCallDataExtractionReturn } from './useCallDataExtraction'

export type CallDataExtractionShadcnComponentProps = UseCallDataExtractionReturn

export function CallDataExtractionShadcnComponent({ calls, transcribeCall }: CallDataExtractionShadcnComponentProps) {
  const rows = calls?.hits ?? []

  const columns = useMemo(
    (): ColumnDef<CallJson, any>[] => [
      {
        id: `id`,
        accessorKey: `id`,
        header: `Call ID`,
        cell: (props) => (
          <Link to={`/settings/call-data-extraction/${props.getValue()}`} className="text-blue-600 hover:underline">
            {props.getValue()}
          </Link>
        ),
        meta: { defaultVisible: true },
      },
      {
        id: `callDate`,
        accessorKey: `callDate`,
        header: `Call Date`,
        cell: (props) => <>{formatDate({ value: props.getValue() }) ?? `-`}</>,
        meta: { defaultVisible: true },
      },
      {
        id: `answered`,
        accessorKey: `answered`,
        header: `Answered`,
        cell: (props) => <>{props.getValue() ? `Yes` : `No`}</>,
        meta: { defaultVisible: true },
      },
      {
        id: `patientNames`,
        accessorKey: `patientNames`,
        header: `Patient Names`,
        cell: (props) => <>{props.getValue() ?? `-`}</>,
        meta: { defaultVisible: true },
      },
      {
        id: `transcribe`,
        header: `Transcribe`,
        size: 120,
        cell: (props) =>
          !props.row.original.ai ? (
            <Button variant="primary" size="sm" onClick={() => transcribeCall(props.row.original.id!)}>
              Transcribe
            </Button>
          ) : null,
        meta: { defaultVisible: true },
      },
    ],
    [transcribeCall],
  )

  return (
    <PageScroll variant="table">
      <SimpleTable columns={columns} data={rows} hideFooter noDataMessage="No calls found" edgePadded />
    </PageScroll>
  )
}
